import * as Yup from "yup";
import React, { Fragment, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import {
  Alert,
  Box,
  Checkbox,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Link, useNavigate } from "react-router-dom";
import { useSnackbar } from "../../snackbar";
import Iconify from "../../iconify";
import { useBoolean } from "../../../hooks/use-boolean";
import { useResponsive } from "../../../hooks/use-responsive";

export default function SetNewPasswordIntegration() {
  const mdUp = useResponsive("up", "md");
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const AUTHENTIK_LOGIN_URL = `${SERVER_URI}/ssologin`;
  const RESET_PASS = `${SERVER_URI}/freeResetPassword`;

  const passwordShow = useBoolean();

  const { enqueueSnackbar } = useSnackbar();
  const [emailData, setEmailData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);


  const navigate = useNavigate(); // for redirection

  React.useEffect(() => {
    const tempToken = localStorage.getItem("temptoken");
    if (!tempToken) {
      setTimeout(() => {
        navigate("/user_Login");
      }, 100);
  
    }
  }, [navigate]);

  const UpdateUserPassSchema = Yup.object().shape({

    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      )
      .required("Password is required"),
    // .oneOf([Yup.ref('confirmPassword')], 'Passwords must match'),

    confirmPassword: Yup.string()
      .min(8, "Confirm Password must be at least 8 characters")
      .required("Confirm password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });
  const defaultValues = {

    password: emailData?.password || "",
    confirmPassword: emailData?.confirmPassword || "",
  };


  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    trigger,
    getValues,
  } = useForm({
    resolver: yupResolver(UpdateUserPassSchema),
    defaultValues,
    mode: "onChange",
    reValidateMode: "onChange",
  });



  const onSubmit = async (data) => {
    setLoading(true);
    const isPasswordValid = await trigger("password");
    // Trigger validation for the email field
    if (!isPasswordValid) {
      setErrorMessage("Please enter a valid mobile Number.");
      return;
    }
    const password = getValues("password");
    

    try {
      let token = localStorage.getItem("temptoken");
      const response = await axios.post(
        RESET_PASS,{password},{
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setErrorMessage("");
      enqueueSnackbar(response.data.message, { variant: "success" });
      reset();
      setTimeout(() => {
        window.location.href = "/user_Login";
      }, 3000);
    } catch (error) {
      if (!navigator.onLine) {
        setErrorMessage(
          "You are currently offline. Please check your network connection."
        );
      } else {
        setErrorMessage(
          error.message || "An error occurred while processing your request."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack direction="column" spacing={2} sx={{ mt: 5, mb: 5 }}>
          <Box>
            <Stack direction="column">
             {mdUp && <Typography
                variant="h3"
                sx={{
                  color: "#1D53E7",
                  fontFamily: "Sofia Sans Extra Condensed",
                  // fontStyle: "italic",
                  fontWeight: 700,
                }}
              >
               SET NEW PASSWORD {" "}
              </Typography>}
              {!mdUp && <Typography
                sx={{
                  color: "#1D53E7",
                  fontSize:28,
                  fontFamily: "Sofia Sans Extra Condensed",
                  fontWeight: 700,
                }}
              >
                 SET NEW PASSWORD{" "}
              </Typography>
              }
        
            </Stack>
          </Box>
          <Box>
            <Stack
              direction={{ lg: "column", xs: "column" }}
              
              spacing={2}
              mb={2}
            >
               <Grid container md={12} xs={12} justifyContent='center'  >
              <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
                <Typography
                  component="label"
                  htmlFor="password_text"
                  sx={{
                    fontWeight: 400,
                  fontFamily: "Roboto Flex",
                  fontSize: "16px",
                  color: "#1F1F1F",
                  }}
                >
                  Password
                </Typography>
                <Controller
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      id="password_text"
                      variant="outlined"
                      size="medium"
                      fullWidth
                      error={!!errors.password}
                      helperText={errors.password?.message}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 3,
                        },
                      }}
                      type={passwordShow.value ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={passwordShow.onToggle}>
                              <Iconify
                                icon={
                                  passwordShow.value
                                    ? "solar:eye-bold"
                                    : "solar:eye-closed-bold"
                                }
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Stack>
              </Grid>
              <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
                <Typography
                  component="label"
                  htmlFor="confirmPassword_text"
                  sx={{
                    fontWeight: 400,
                  fontFamily: "Roboto Flex",
                  fontSize: "16px",
                  color: "#1F1F1F",
                  }}
                >
                  Confirm Password
                </Typography>
                <Controller
                  name="confirmPassword"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      id="confirmPassword_text"
                      variant="outlined"
                      size="medium"
                      fullWidth
                      error={!!errors.confirmPassword}
                      helperText={errors.confirmPassword?.message}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 3,
                        },
                      }}
                      type={passwordShow.value ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={passwordShow.onToggle}>
                              <Iconify
                                icon={
                                  passwordShow.value
                                    ? "solar:eye-bold"
                                    : "solar:eye-closed-bold"
                                }
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Stack>
            </Stack>

            {errorMessage && (
              <Alert
                variant="outlined"
                severity="error"
                sx={{ mt: 1, borderRadius: 3 }}
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setErrorMessage(null);
                    }}
                  >
                    <Iconify color="red" icon="basil:cross-outline" />
                  </IconButton>
                }
              >
                {errorMessage}
              </Alert>
            )}
            {errors.term_conditions && (
              <Alert
                variant="outlined"
                severity="error"
                sx={{ mt: 1, borderRadius: 3 }}
              >
                {errors.term_conditions?.message}
              </Alert>
            )}
        
          </Box>

          <Box>
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={3}
              sx={{
                textAlign: "center",
                alignItems: "center",
                // justifyContent:'center'
              }}
            >
              <Grid container md={4} xs={8} justifyContent='center'  >
              <LoadingButton
                size="large"
                fullWidth
                sx={{
                  fontFamily: "Roboto Flex",
                  backgroundColor: "#C7F760",
                  color: "#1E53E8",
                  textTransform: "none",
                  fontWeight: 900,
                  "&:hover": {
                    backgroundColor: "#1E53E8",
                    color: "#C7F760",
                  },
                }}
                type="submit"
                loading={loading}
                variant="contained"
              >
                Confirm
              </LoadingButton>
              </Grid>
              <Typography
                sx={{
                  fontSize: 16,
                  fontFamily: "Roboto Flex",
                  fontWeight: "400",
                  wordWrap: "break-word",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                Back to{" "}
                <Link
                  to="/user_Login"
                  style={{ color: "#1E53E8", textDecoration:'underline' }}
                  // onClick={() => window.open(AUTHENTIK_LOGIN_URL, "_self")}
                >
                  Log in?
                </Link>
              </Typography>
            </Stack>
            
          </Box>
        </Stack>
      </form>
    </Fragment>
  );
}
